var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 37.1251C11.1562 37.1251 1.75 31.6564 1.75 19.6564C1.75 7.65637 11.1562 2.18762 19.875 2.18762C24.7188 2.18762 29.1875 3.78137 32.5 6.68762C36.0938 9.87512 38 14.3751 38 19.6564C38 24.9376 36.0938 29.4064 32.5 32.5939C29.1875 35.5001 24.6875 37.1251 19.875 37.1251Z",
    fill: "url(#paint0_radial_878_120442)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8402 9.272C36.5059 11.9595 37.3746 15.1595 37.3746 18.7189C37.3746 24.0001 35.4684 28.4689 31.8746 31.6564C28.5621 34.5626 24.0621 36.1876 19.2496 36.1876C13.6059 36.1876 7.68711 33.8907 4.19336 29.0189C7.55586 34.5376 13.8809 37.1251 19.8746 37.1251C24.6871 37.1251 29.1871 35.5001 32.4996 32.5939C36.0934 29.4064 37.9996 24.9376 37.9996 19.6564C37.9996 15.6751 36.9152 12.1376 34.8402 9.272Z",
    fill: "#D84213"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2314 32.2314C26.1252 32.1907 26.0283 32.1251 25.9533 32.0376C22.9127 28.8782 17.8846 28.7814 14.7252 31.822C14.6533 31.8939 14.5783 31.9657 14.5096 32.0376C14.4346 32.1251 14.3377 32.1907 14.2314 32.2314C13.9971 32.3189 13.7314 32.2689 13.5439 32.1032C13.3596 31.9407 13.2971 31.6814 13.3908 31.4532C14.3221 29.0626 17.0908 27.1876 20.2314 27.1876C23.3721 27.1876 26.1408 29.0626 27.0721 31.4501C27.1658 31.6782 27.1033 31.9376 26.9189 32.1001C26.7314 32.2657 26.4658 32.3157 26.2314 32.2314Z",
    fill: "#422B0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1681 21.5064C17.4681 20.6251 14.5837 18.9314 13.5431 18.4376C13.1556 18.2595 12.7525 18.1157 12.34 18.0095C12.265 17.9876 12.1837 17.9782 12.1056 17.9782C11.69 17.9876 11.3337 18.2845 11.2494 18.6939C11.1525 19.1189 11.3712 19.5564 11.7712 19.7314C12.2619 19.972 13.1181 20.4283 14.0056 20.9314C13.265 21.372 12.8119 22.172 12.8119 23.0345V23.4907C12.8119 24.7845 13.8619 25.8345 15.1556 25.8345C16.4494 25.8345 17.4994 24.7845 17.4994 23.4907V23.0345C17.4994 23.0157 17.4994 23.0001 17.4994 22.9814C17.8337 22.9595 18.1337 22.7595 18.2806 22.4595C18.4337 22.147 18.39 21.7751 18.1681 21.5064Z",
    fill: "#422B0D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2244 18.6939C29.1369 18.2814 28.7744 17.9876 28.3526 17.9845C28.2744 17.9845 28.1932 17.9939 28.1182 18.0157C27.7057 18.1189 27.3026 18.2626 26.9151 18.4376C25.8744 18.9251 22.9901 20.6251 22.2901 21.5001C22.0682 21.772 22.0307 22.147 22.1869 22.4595C22.3369 22.7626 22.6338 22.9595 22.9713 22.9814C22.9713 23.0001 22.9713 23.0157 22.9713 23.0345V23.4907C22.9713 24.7845 24.0213 25.8345 25.3151 25.8345C26.6088 25.8345 27.6588 24.7845 27.6588 23.4907V23.0345C27.6588 22.1751 27.2057 21.3782 26.4682 20.9376C27.3557 20.4345 28.2119 19.9782 28.7026 19.7376C29.1057 19.5626 29.3276 19.122 29.2244 18.6939Z",
    fill: "#422B0D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0367 21.3907C14.593 21.1782 14.0586 21.3657 13.843 21.8095C13.6773 22.1564 13.7523 22.572 14.0305 22.8407C14.4742 23.0532 15.0086 22.8657 15.2242 22.422C15.3898 22.0751 15.3148 21.6595 15.0367 21.3907Z",
    fill: "#896024"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1969 21.3907C24.7531 21.1782 24.2187 21.3657 24.0031 21.8095C23.8375 22.1564 23.9125 22.572 24.1906 22.8407C24.6344 23.0532 25.1687 22.8657 25.3844 22.422C25.55 22.0751 25.475 21.6595 25.1969 21.3907Z",
    fill: "#896024"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_878_120442",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.875 19.6563) scale(17.7999)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FAC742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBBA3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FBA931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FC9224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FE7413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5100"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRage);
export default __webpack_public_path__ + "static/media/rage.a66a5df51cf3fbab7bb4d621d6be8dfd.svg";
export { ForwardRef as ReactComponent };